module.exports = __webpack_public_path__ + "img/点对齐-角标2.d13e6e13.svg";